<template>
<div>
    <b-modal ref="modal" title="Editar Configurações" header-class="border-bottom-0" size="lg">
        <div class="row">
            <div class="col-md-3">
                <h5 class="text-primary">
                    <i class="fas fa-cogs" /> Configurações
                </h5>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-md-6">
                <text-input v-model="form.csc.value" alias="CSC - Código de segurança do contribuinte:" />
            </div>
            <div class="col-md-6">
                <text-input v-model="form.csc_id.value" alias="(ID) do contribuinte no banco de dados da SEFAZ" />
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-md-12">
                <!--<select-input alias="Ambiente de Emissão" v-model="form.ambiente_nfe.value" :options="form.ambiente_nfe.options" />-->
                <b-form-group label="Ambiente de emissão de Nfe / Nfce">
                    <b-form-radio-group id="radio-group-2" v-model="form.ambiente_nfe.value" name="radio-sub-component">
                        <b-form-radio value="2">
                            Ambiente de Homologação
                            <br />
                            <small class="text-muted">Ambiente utilizado para testes de emissão de nfe's e nfce's.</small>
                        </b-form-radio>
                        <b-form-radio value="1">
                            Ambiente de Produção
                            <br />
                            <small class="text-muted">Ambiente de emissão de nfe's e nfce's reais.</small>
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
        </div>
        <div slot="modal-footer">
            <button role="button" class="btn btn-outline-secondary" @click="$refs.modal.hide()">
                <i class="fas fa-times"></i> Cancelar
            </button>
            <button role="button" class="btn btn-success" style="margin-left:5px" @click="store">
                <i class="fas fa-check"></i> Salvar
            </button>
        </div>
    </b-modal>
</div>
</template>

<script>
import Form from "./../../mixins/Form.js";

export default {
    data: function () {
        return {
            form: new Form({
                ambiente_nfe: {},

                csc: {},

                csc_id: {}
            })
        };
    },

    methods: {
        open(company) {
            this.$refs.modal.show();

            this.form.setValues(company);
        },

        store() {
            if (this.form.isValid()) {
                this.$store.commit("showLoading");

                // var message =
                //   "O cadastro de " + this.form.name.value + " foi atualizado!";

                axios
                    .post("api/companyNfeConfig/store", this.form.getValues())
                    .then(response => {

                        this.$store.commit('updateCompanyConfig', {
                            company_config: response.data
                        })

                        this.$refs.modal.hide();

                        this.$emit("stored", this.form.getValues());

                        //this.makeToast('success')
                        this.$store.commit("showAlert", {
                            message: message,
                            type: "success"
                        });

                        this.$store.commit("hideLoading");
                    })
                    .catch(error => {
                        this.error = error;

                        this.$store.commit("hideLoading");
                    });
            }
        }
    }
};
</script>
